import { Alert, Button, CrossIcon, Dialog, Pane, Text } from "evergreen-ui";
import React, { useEffect, useState } from "react";
import { FaReceipt } from "react-icons/fa";
import { MdPayments } from "react-icons/md";
import { IoNewspaper, IoQrCodeOutline } from "react-icons/io5";
import NewsDetail from "./NewsDetail";
import ComponentPay from "./ComponentPay";
import { dates } from "./datanurse";
import StatusManageRegist_0 from "./StatusManageRegist/StatusManageRegist_0";
import StatusManageRegist_1 from "./StatusManageRegist/StatusManageRegist_1";
import StatusManageRegist_4 from "./StatusManageRegist/StatusManageRegist_4";
import StatusManageRegist_6 from "./StatusManageRegist/StatusManageRegist_6";
import StatusManageRegist_9 from "./StatusManageRegist/StatusManageRegist_9";
import StatusManageRegist_5 from "./StatusManageRegist/StatusManageRegist_5";
import StatusManageRegist_11 from "./StatusManageRegist/StatusManageRegist_11";
import StatusManageRegist_12 from "./StatusManageRegist/StatusManageRegist_12";
function ManageRegistNew({ data }) {
  const [DataRegister, setDataRegister] = useState();
  useEffect(() => {
    const DATAREGISTER = Array(data);
    setDataRegister(DATAREGISTER);
  }, [data]);

  function renderStatusUI(status) {
    console.log("Status:", status);
    switch (status) {
      case "0":
        return <StatusManageRegist_0 DataRegister={DataRegister} />;
      case "1":
        return <StatusManageRegist_1 DataRegister={DataRegister} />;
      case "11":
        return <StatusManageRegist_11 DataRegister={DataRegister} />;
      case "12":
        return <StatusManageRegist_12 DataRegister={DataRegister} />;
      case "4":
        return <StatusManageRegist_4 DataRegister={DataRegister} />;
      case "5":
        return <StatusManageRegist_5 DataRegister={DataRegister} />;
      case "6":
        return <StatusManageRegist_6 DataRegister={DataRegister} />;
      case "9":
        return <StatusManageRegist_9 DataRegister={DataRegister} />;
      default:
        return <StatusManageRegist_0 DataRegister={DataRegister} />;
    }
  }

  return (
    <>
      <Pane display="flex" flexDirection="column">
        {
          Array.isArray(DataRegister) && DataRegister.length > 0 ? (
            <>
              {DataRegister.map((item, index) => (
                renderStatusUI(item.REGISTER_STATUS)
              ))}
            </>
          ) : (
            <Pane
              color="#ffffff"
              backgroundColor="#ff0000"
              height="100%"
              paddingY={4}
              paddingX={5}
              fontSize={16}
              fontFamily=""
              fontWeight={700}
              marginBottom={0}
              display="flex" alignItems="center" justifyContent="center"
            >
              <Text color="#ffffff" fontWeight={700}>
                <CrossIcon /> ไม่พบข้อมูล
              </Text>
            </Pane>
          )
        }
      </Pane>
      {DataRegister && DataRegister.length > 0 && (

        <NewsDetail
          TYPE={DataRegister[0].REGISTER_TYPE_ID}
          MAJOR={DataRegister[0].Major1_MAJOR_ID}
          ROB={DataRegister[0].ROB_ID}
        />
      )}
    </>

  );
}

export default ManageRegistNew;
